var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isReady
    ? _c("div", { staticClass: "payment-methods-page" }, [
        _c("div", { staticClass: "payment-method-actions" }, [
          _vm.achEnabled
            ? _c(
                "button",
                {
                  staticClass: "portal-button outline",
                  attrs: { type: "button" },
                  on: { click: _vm.linkNewAccount }
                },
                [
                  _c("portal-icon", { attrs: { name: "plus", size: 17 } }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("invoices.ach-account.new-account")) +
                      " "
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "button",
            {
              staticClass: "portal-button primary",
              attrs: { type: "button" },
              on: { click: _vm.managePaymentMethods }
            },
            [
              _c("portal-icon", { attrs: { name: "settings", size: 17 } }),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("invoices.ach-account.manage-payment-methods")
                  ) +
                  " "
              )
            ],
            1
          )
        ]),
        _c(
          "div",
          {
            staticClass: "payment-method-table-shell portal-compact-list-shell"
          },
          [
            _c("v-data-table", {
              staticClass: "portal-compact-table payment-method-table",
              attrs: {
                headers: _vm.headers,
                "hide-default-footer": true,
                "disable-pagination": true,
                "mobile-breakpoint": 0,
                items: _vm.accounts,
                "no-data-text": _vm.$t("invoices.viewer.link-account")
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "item.label",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c("div", { staticClass: "payment-method-name" }, [
                          _c(
                            "span",
                            {
                              staticClass: "method-icon",
                              attrs: { "aria-hidden": "true" }
                            },
                            [
                              _c("portal-icon", {
                                attrs: {
                                  name:
                                    item.type === "card"
                                      ? "credit-card"
                                      : "landmark",
                                  size: 18
                                }
                              })
                            ],
                            1
                          ),
                          _c("span", { staticClass: "portal-cell-truncate" }, [
                            _vm._v(_vm._s(_vm.normalizedLabel(item)))
                          ])
                        ])
                      ]
                    }
                  },
                  {
                    key: "item.routing",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c("span", { staticClass: "portal-cell-muted" }, [
                          _vm._v(_vm._s(item.routing || "--"))
                        ])
                      ]
                    }
                  },
                  {
                    key: "item.last4",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c("span", { staticClass: "account-ending" }, [
                          _vm._v("•••• " + _vm._s(item.last4))
                        ])
                      ]
                    }
                  },
                  {
                    key: "item.status",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        item.status === "verified"
                          ? _c(
                              "portal-status-pill",
                              {
                                attrs: {
                                  background: "var(--v-success_10-base)",
                                  color: "var(--v-success-base)"
                                }
                              },
                              [_vm._v(" " + _vm._s(item.status) + " ")]
                            )
                          : _c(
                              "button",
                              {
                                staticClass: "verify-action",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.verifyAccount(item)
                                  }
                                }
                              },
                              [
                                _c("portal-icon", {
                                  attrs: { name: "alert-circle", size: 15 }
                                }),
                                _vm._v(
                                  " " + _vm._s(_vm.$t("global.verify")) + " "
                                )
                              ],
                              1
                            )
                      ]
                    }
                  },
                  {
                    key: "item.id",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        item.type === "bank_account"
                          ? _c(
                              "button",
                              {
                                staticClass: "row-action danger",
                                attrs: {
                                  type: "button",
                                  "aria-label": _vm.$t("global.delete")
                                },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.deleteAccount(item)
                                  }
                                }
                              },
                              [
                                _c("portal-icon", {
                                  attrs: { name: "trash-2", size: 17 }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ],
                null,
                false,
                2186161991
              )
            })
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }